import {Rest} from "../../common/api/rest/Rest";
import {Segments} from "../model/segment/Segments";

export class RestSegment extends Rest {
    getSegments(segmentIdList?: string): Promise<Segments> {
        return this._client.get(`customer/segment${segmentIdList ? ("?id=" + segmentIdList) : ""}`, Segments) as Promise<Segments>;
    }
}
